// Dynamic app version — single source of truth is the installed Android
// package metadata (versionName/versionCode) read via the Capacitor App
// plugin at runtime. No hardcoded version constants in JavaScript.
import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

let cached = null;
let pending = null;

export async function getAppInfo() {
  if (cached) return cached;
  if (!pending) {
    pending = (async () => {
      if (Capacitor.isNativePlatform()) {
        try {
          const info = await App.getInfo();
          cached = { version: info.version || '', build: String(info.build || '') };
          return cached;
        } catch (_) {
          // fall through to web fallback
        }
      }
      cached = { version: null, build: null };
      return cached;
    })();
  }
  return pending;
}

// React hook: { version, build, label }. On web (or if native info is
// unavailable) version/build are null and label falls back to "Web".
export function useAppVersion() {
  const [info, setInfo] = useState(cached || { version: null, build: null });
  useEffect(() => {
    let on = true;
    getAppInfo().then((v) => { if (on) setInfo(v); });
    return () => { on = false; };
  }, []);
  const label = info.version ? `v${info.version} (${info.build})` : 'Web';
  return { ...info, label };
}
